(function() {
  const sections = document.querySelectorAll("[data-tabs-y-labelledby]");
  const tabsArea = document.querySelectorAll("[data-tabs-y]");
  if (!tabsArea.length || !sections.length) {
    return;
  }

  findMatchCountry();

  tabsArea.forEach(item => {
    const tabs = item.querySelectorAll("[data-tabs-y-controls]");
    if (!tabs.length) {
      return;
    }

    if (item.getAttribute("data-tabs-y") === "mobile") {
      item.addEventListener("change", e => {
        const target = e.target as HTMLSelectElement;
        if (!target) {
          return;
        }
        const tab = target.options[target.selectedIndex];
        initTabs(tabs, tab, e);
      });
    }

    if (item.getAttribute("data-tabs-y") === "desktop") {
      tabs.forEach(tab => {
        if (tab.classList.contains("active")) {
          tab.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start"
          });
        }
        tab.addEventListener("click", e => {
          initTabs(tabs, tab, e);
        });
      });
    }
  });

  function initTabs(tabs: any, tab: any, e: any) {
    e.preventDefault();
    removeActiveTab(tabs);
    addActiveTab(tab);
    editHelpCtrLink(tab);
    editUrlParams(tab);
  }

  function removeActiveTab(tabs: any) {
    tabs.forEach((tab: any) => {
      tab.classList.remove("active");
    });
    sections.forEach(section => {
      section.classList.remove("active");
    });
  }

  function addActiveTab(tab: any) {
    tab.classList.add("active");
    const value = getCode(tab);
    const matchingSection = document.querySelector(
      "[data-tabs-y-labelledby=" + value + "]"
    );
    if (!matchingSection) {
      return;
    }
    matchingSection.classList.add("active");
  }

  function editHelpCtrLink(tab: any) {
    const helpCtr = document.getElementById("btn_contact_us_help");
    if (!helpCtr || !tab.hasAttribute("data-help-ctr-link")) {
      return;
    }

    const url = tab.getAttribute("data-help-ctr-link");
    helpCtr.setAttribute("href", url);
  }

  function editUrlParams(tab: any) {
    const country = getCode(tab);
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("country", country);
    history.replaceState(null, "contactUs", "?" + queryParams.toString());
  }

  function getCode(tab: any) {
    return tab.getAttribute("data-tabs-y-controls");
  }

  function activateTab(items: any) {
    items.forEach((item: any) => {
      if (item.tagName === "OPTION") {
        item.setAttribute("selected", "selected");
      }

      item.classList.add("active");
      editHelpCtrLink(item);
    });
  }

  function filterArrayCountries(array: any, filterParam: any) {
    return Array.prototype.filter.call(array, country => {
      return country.getAttribute("data-country") === filterParam;
    });
  }

  function findMatchCountry() {
    const countryItems = document.querySelectorAll("[data-country]");
    const searchParams = new URLSearchParams(window.location.search);
    const countryParam = searchParams.get("country");

    if (countryParam) {
      const SearchParamResult = filterArrayCountries(
        countryItems,
        countryParam.toUpperCase()
      );

      if (SearchParamResult.length) {
        activateTab(SearchParamResult);
        return;
      }
    }

    const { geoIP } = window as any;
    const { currentRegulator } = window as any;
    let { countryGroup } = window as any;

    if (geoIP && geoIP !== "") {
      const geoIPResult = filterArrayCountries(countryItems, geoIP);

      if (geoIPResult.length) {
        activateTab(geoIPResult);
        return;
      }
    }

    if (countryGroup) {
      if (countryGroup === "EU") {
        countryGroup = "EUROPE";
      }

      if (countryGroup === "OTHERS") {
        countryGroup = "GLOBAL";
      }

      if (currentRegulator === "EFSA" || currentRegulator === "CYSEC") {
        countryGroup = "EUROPE";
      }

      const countryGroupResult = filterArrayCountries(
        countryItems,
        countryGroup
      );

      if (countryGroupResult.length) {
        activateTab(countryGroupResult);
        return;
      }
    }
  }
})();
